import getSymbolFromCurrency from 'currency-symbol-map';
import { Tag } from 'antd';
import { Component } from 'react';
import { formatDate, mapBonusStatus } from '../../services/utils';

export default class MyReferralsTieredBonus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			referral: props.referral,
		};
	}

	componentDidUpdate(prevProps) {
		const { referral } = this.props;
		if (prevProps.referral !== referral) {
			this.setState({ referral });
		}
	}

	getBonusTagColor = (bonusStatus) => {
		const bonusStatusColors = {
			pending: 'var(--tan-hide)',
			needsReview: 'var(--mellow-yellow)',
			earned: 'var(--fern)',
			ineligible: 'var(--sunset-orange)',
			paid: 'var(--forest-green)',
		};
		return bonusStatusColors[bonusStatus] || 'default';
	};

	render() {
		const { currentUser } = this.props;
		const { referral } = this.state;
		const symbol = getSymbolFromCurrency(currentUser?.userGroup?.currency);
		let bonusAmount = 0;
		const referralStatus = referral?.status;
		const bonuses = this.props.bonusesData;
		const preStartUserGroupName = currentUser?.company?.userGroups.find(
			(group) => group.id === currentUser?.company.preStartUserGroupId
		)?.name;
		const preStartEnabled =
			currentUser?.company?.preStartEnabled &&
			preStartUserGroupName &&
			referral?.origin === 'pre_start';
		let items = '';
		if (window.location.href.includes('/jobs/')) {
			items = bonuses.map((bonus) => {
				bonusAmount += Number.parseInt(bonus?.amountDue || 0, 10);
				bonusAmount = `${bonusAmount}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
				const languageCode = this.props?.currentUser?.languageCode;
				const bonusStatus =
					this.props.currentUser?.role !== 'admin' &&
					bonus?.bonusStatus === 'needsReview'
						? 'Pending'
						: mapBonusStatus(
								bonus?.bonusStatus,
								this.props.currentUser?.company
							);
				const earnedDate = formatDate(bonus?.earnedDate, languageCode);

				const item = referralStatus === 'hired' && (
					<li key={bonus?.id}>
						<span className="text-green">
							{`${symbol}`}
							{bonus?.amountDue
								.toString()
								.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',')}
						</span>
						<span>{bonus?.recipientType}</span>
						<span>{earnedDate}</span>
						<span style={{ color: this.getBonusTagColor(bonus?.bonusStatus) }}>
							{bonusStatus}
						</span>
						{preStartEnabled && (
							<Tag color="green">{preStartUserGroupName}</Tag>
						)}
					</li>
				);

				return item;
			});
		} else {
			items = bonuses.map((bonus) => {
				const recipientType = bonus?.recipientType;
				if (recipientType === 'employee') {
					bonusAmount += Number.parseInt(bonus?.amountDue || 0, 10);
					bonusAmount = `${bonusAmount}`.replaceAll(
						/\B(?=(\d{3})+(?!\d))/g,
						','
					);
				}

				const languageCode = this.props?.currentUser?.languageCode;
				const bonusStatus =
					this.props.currentUser?.role !== 'admin' &&
					bonus?.bonusStatus === 'needsReview'
						? 'Pending'
						: mapBonusStatus(
								bonus?.bonusStatus,
								this.props.currentUser?.company
							);
				const earnedDate = formatDate(bonus?.earnedDate, languageCode);

				const item = referralStatus === 'hired' &&
					recipientType === 'employee' && (
						<li key={bonus?.id}>
							<span className="text-green">
								{`${symbol}`}
								{bonus?.amountDue
									.toString()
									.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',')}
							</span>
							<span>{earnedDate}</span>
							<span
								style={{ color: this.getBonusTagColor(bonus?.bonusStatus) }}
							>
								{bonusStatus}
							</span>
							{preStartEnabled && (
								<Tag color="green">{preStartUserGroupName}</Tag>
							)}
						</li>
					);

				return item;
			});
		}

		return <ul className="bonus-summary-list">{items}</ul>;
	}
}
